import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { string } from 'prop-types';
import isEmpty from 'lodash/isEmpty';

import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';

import { fetchRebateData, resetRebateData } from '../../actions/RebatesAction';

const EcoRebatesModalNew = ({
    skuId = '',
    rebateInfoPdp = {},
    isPDPPage = false,
    rebateErrorPdp = {},
    fromMiniPDP = false,
}) => {
    const rebateInfo =
        isPDPPage || fromMiniPDP
            ? rebateInfoPdp
            : useSelector(
                  (state) =>
                      state?.rebatesInfo?.data?.rebateResponse?.productRebateDetails[0]
                          ?.rebatePrograms[0] || []
              );
    const rebateError =
        isPDPPage || fromMiniPDP
            ? rebateErrorPdp
            : useSelector((state) => state?.rebatesInfo?.error || false);
    const dispatch = useDispatch();

    /* istanbul ignore next */
    const handleDownload = (claimFormURL = '') => {
        if (!isEmpty(claimFormURL)) {
            const link = document.createElement('a');
            link.href = claimFormURL;
            link.target = '_blank'; // To open in a new tab
            link.click();
        }
    };

    useEffect(() => {
        if (!(isPDPPage || fromMiniPDP)) {
            dispatch(fetchRebateData(skuId));
            /* istanbul ignore next */
            return () => {
                dispatch(resetRebateData());
            };
        }
    }, [isPDPPage, fromMiniPDP]);

    if (isEmpty(rebateInfo) && !rebateError) {
        return null;
    }

    return (
        <div className={`${dt(['flex', 'pb-6', 'px-6'])}`}>
            <div>
                {rebateError && isEmpty(rebateInfo) ? (
                    <div
                        className={`${dt([
                            'font-open-sans-bold',
                            'absolute',
                            'top-0',
                            'bottom-0',
                            'left-0',
                            'right-0',
                            'h-[100px]',
                            'text-center',
                            'm-auto',
                        ])}`}
                    >
                        {' '}
                        Rebate Data Not Available
                    </div>
                ) : (
                    <div>
                        <div
                            className={`${dt([
                                'text-[#E71324]',
                                'font-semibold',
                                'not-italic',
                                'font-sans',
                                'text-xlarge',
                                'pt-6',
                                'mb-2',
                                'text-justify',
                            ])}`}
                        >
                            {rebateInfo?.amountLabel || ''}
                        </div>

                        <div className={`${dt(['pb-4', 'pr-4'])}`}>
                            <div className={`${dt(['flex', 'justify-between'])}`}>
                                <span
                                    className={`${dt([
                                        'text-black',
                                        'font-semibold',
                                        'not-italic',
                                        'font-sans',
                                        'text-medium',
                                    ])}`}
                                >
                                    Buy on or After:
                                </span>
                                <span
                                    className={`${dt([
                                        'text-black',
                                        'font-normal',
                                        'not-italic',
                                        'font-sans',
                                        'text-medium',
                                    ])}`}
                                >
                                    {' '}
                                    {rebateInfo?.purchaseDates?.buyAfter || ''}
                                </span>
                            </div>
                            <div className={`${dt(['flex', 'justify-between'])}`}>
                                <span
                                    className={`${dt([
                                        'text-black',
                                        'font-semibold',
                                        'not-italic',
                                        'font-sans',
                                        'text-medium',
                                    ])}`}
                                >
                                    Buy on or Before:
                                </span>
                                <span
                                    className={`${dt([
                                        'text-black',
                                        'font-normal',
                                        'not-italic',
                                        'font-sans',
                                        'text-medium',
                                    ])}`}
                                >
                                    {' '}
                                    {rebateInfo?.purchaseDates?.buyBefore || ''}
                                </span>
                            </div>
                            <div className={`${dt(['flex', 'justify-between'])}`}>
                                <span
                                    className={`${dt([
                                        'text-black',
                                        'font-semibold',
                                        'not-italic',
                                        'font-sans',
                                        'text-medium',
                                    ])}`}
                                >
                                    Claim By:
                                </span>
                                <span
                                    className={`${dt([
                                        'text-black',
                                        'font-normal',
                                        'not-italic',
                                        'font-sans',
                                        'text-medium',
                                    ])}`}
                                >
                                    {rebateInfo?.purchaseDates?.claimBy || ''}
                                </span>
                            </div>
                        </div>

                        <div
                            className={`${dt([
                                'max-w-sm',
                                'mx-auto',
                                'px-6',
                                'border',
                                'border-[#999]',
                                'border-solid',
                                'rounded-lg',
                            ])}`}
                        >
                            <button
                                onClick={() => handleDownload(rebateInfo?.claimFormURL)}
                                className={`${dt([
                                    'w-full',
                                    'flex',
                                    'items-center',
                                    'justify-center',
                                    'gap-2',
                                    'py-2',
                                    'border',
                                    'border-gray-300',
                                    'rounded-lg',
                                ])} rebatesDownload`}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                >
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M16.7667 5.03867C17.7867 5.03867 18.5 5.72401 18.5 6.70534V11.5773C18.5 12.5587 17.7867 13.244 16.7667 13.244H16.2253L16.4333 15.5513C16.4333 16.3207 15.8993 16.8333 15.1 16.8333H5.89933C5.1 16.8333 4.566 16.3207 4.566 15.5513L4.772 13.244H4.23267C3.21267 13.244 2.5 12.5587 2.5 11.5773V6.64134C2.5 5.71267 3.22867 5.03867 4.23267 5.03867H16.7667ZM14.5 8.37201H6.5C6.30067 8.37201 5.96667 8.43001 5.96667 8.82067C5.96667 8.84267 5.96533 8.86467 5.96333 8.88601L5.36667 15.58C5.376 15.906 5.55067 16.0647 5.89933 16.0647H15.1C15.448 16.0647 15.6233 15.906 15.6327 15.58L15.036 8.95134C15.034 8.92867 15.0327 8.90667 15.0327 8.88467C15.0327 8.53934 14.8587 8.37201 14.5 8.37201ZM13.566 13.5C13.7873 13.5 13.9667 13.6727 13.9667 13.8847C13.9667 14.0973 13.7873 14.2693 13.566 14.2693H7.43333C7.212 14.2693 7.03267 14.0973 7.03267 13.8847C7.03267 13.6727 7.212 13.5 7.43333 13.5H13.566ZM13.3 10.6793C13.5207 10.6793 13.6993 10.852 13.6993 11.0647C13.6993 11.2767 13.5207 11.4487 13.3 11.4487H7.69933C7.47867 11.4487 7.3 11.2767 7.3 11.0647C7.3 10.852 7.47867 10.6793 7.69933 10.6793H13.3ZM14.1 3.5C14.3207 3.5 14.5 3.67267 14.5 3.88467C14.5 4.09733 14.3207 4.26933 14.1 4.26933H6.89933C6.67867 4.26933 6.5 4.09733 6.5 3.88467C6.5 3.67267 6.67867 3.5 6.89933 3.5H14.1Z"
                                        fill="#202020"
                                    />
                                </svg>
                                <span
                                    className={`${dt([
                                        'text-black',
                                        'font-semibold',
                                        'not-italic',
                                        'font-sans',
                                        'text-medium',
                                    ])}`}
                                >
                                    Get Form
                                </span>
                            </button>
                        </div>
                        <div className={`${dt(['mt-4'])}`}>
                            <p
                                className={`${dt([
                                    'p-6',
                                    'rounded-lg',
                                    'bg-[#F2F2F2]',
                                    'text-base',
                                    'text-left',
                                    'leading-6',
                                ])}`}
                            >
                                Please reference specific rebate form for detailed instructions.
                                Submit completed form and required store receipt or email
                                confirmation.
                            </p>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

EcoRebatesModalNew.propTypes = {
    skuId: string.isRequired,
};

export default EcoRebatesModalNew;
